import { HttpContextToken } from '@angular/common/http';
import { CountryCode } from '../../core/country/country.model';

/**
 * Overrides which country's API origin the country-domain-base-url interceptor resolves for a
 * request. `null` (the default) keeps the globally active country. Set per request by
 * `CountryScopedHttpService` for multi-country fan-out; mirrors the `jwt-interceptor-options`
 * HttpContext token pattern.
 */
export const TARGET_COUNTRY = new HttpContextToken<CountryCode | null>(() => null);
